
























import Vue from "vue";
import { ref, computed, onMounted } from "@vue/composition-api";
import Modal from "@/components/root/modal/Modal.vue";
import { ModalConfig } from "@/components/root/modal";
import RiskStoryDetailsModal from "./RiskStoryDetailsModal.vue";
import EventDetailsLegacyModal from "./EventDetailsLegacyModal.vue";
import { fetchRiskStory, enrichEntities } from "./risk-story/risk-story.api";

export default Vue.extend({
  name: "EventDetailsGate",
  components: { Modal, RiskStoryDetailsModal, EventDetailsLegacyModal },
  props: ["modalData"],
  setup(props: any) {
    const decided = ref(false);
    const supported = ref(false);
    const riskModalData = ref<any>(props.modalData);
    // Flag the legacy fallback so it can show the "old events unsupported" notice.
    const legacyModalData = computed(() => ({
      ...(props.modalData as any),
      unsupportedNotice: true,
    }));
    const loadingConfig: ModalConfig = {
      title: "",
      desc: "",
      blank: true,
      width: "60rem",
      height: "50rem",
      withTopRightCloseBtn: true,
    };

    onMounted(async () => {
      const internalEventId = (props.modalData as any)?.item?.id;
      const model = await fetchRiskStory(internalEventId);
      if (model && model.entities.length > 0) {
        const enriched = await enrichEntities(model.entities);
        riskModalData.value = {
          ...props.modalData,
          riskStoryEntities: enriched,
          riskStorySummary: model.summary,
        };
        supported.value = true;
      } else {
        supported.value = false;
      }
      decided.value = true;
    });

    return { decided, supported, riskModalData, legacyModalData, loadingConfig };
  },
});
